import { render, staticRenderFns } from "./OwnerFreezer.vue?vue&type=template&id=8b6b5b5e&"
import script from "./OwnerFreezer.vue?vue&type=script&lang=js&"
export * from "./OwnerFreezer.vue?vue&type=script&lang=js&"
import style0 from "./OwnerFreezer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports